import { Constructor } from '@skylab-shared/types';
import { Validations } from '../../validation';
import { ModelBase } from './model-base';
import { ModelMetadataContainer } from './model-metadata-container';
import { PropertyMetadata } from './property-metadata';

export const copyPropertiesFromParent = (modelMetadata: ModelMetadataContainer, modelType: Constructor<ModelBase>): void => {
    const [_, ...tail] = getModelHierarchy(<Constructor<ModelBase>> modelType);
    tail
        .map(modelType => <ModelMetadataContainer> Reflect.getMetadata('skl:model', modelType))
        .reduceRight((properties, metadata) => [...metadata.properties, ...properties], <PropertyMetadata[]> [])
        .forEach(propertyMetadata => modelMetadata.setPropertyMetadata(propertyMetadata.propertyName, propertyMetadata));
};

export const copyValidationsFromParent = (validations: Validations, modelType: Constructor<ModelBase>): Readonly<Validations> => {
    const [_, ...tail] = getModelHierarchy(<Constructor<ModelBase>> modelType);
    return tail
        .map(modelType => <Validations> Reflect.getMetadata('skl:validations', modelType))
        .reduceRight((merged, modelValidations) => ({ ...merged, ...modelValidations }), validations);
};

const getModelHierarchy = (modelType: Constructor<ModelBase>, chain: Constructor<ModelBase>[] = []): Constructor<ModelBase>[] => {
    return ModelBase.isPrototypeOf(modelType)
        ? getModelHierarchy(Object.getPrototypeOf(modelType), [...chain, modelType])
        : chain;
};
